export default "__VITE_ASSET__PP$qVVO6__"